// WARNING: KEEP TEXTS SAME HERE AS IN TOURNIFY LIVE AND HEROKU
export default {
  teamDivisionQuestion: {
    nl: "Voor welke divisie wil je een team inschrijven?",
    en: "For which division would you like to register a team?",
    de: "Für welche Liga willst Du Dein Team registrieren?",
    fr: "Dans quelle division souhaitez-vous inscrire une équipe ?",
    es: "Para qué liga quieres inscribir un equipo?",
    pl: "Do jakiej ligi chcesz zapisać drużynę?",
  },
  playerDivisionQuestion: {
    nl: "Aan welke divisie wil je meedoen?",
    en: "For which division would you like to register?",
    de: "Für welche Liga willst du dich registrieren?",
    fr: "Dans quelle division souhaitez-vous s'inscrire ?",
    es: "¿Para qué liga quieres inscribirte?",
    pl: "W której lidze chcesz brać udział?",
  },
  teamNameQuestion: {
    nl: "Wat is jullie teamnaam?",
    en: "What is the name of your team?",
    de: "Wie lautet Euer Teamname?",
    fr: "Quel est le nom de votre équipe ?",
    es: "¿Cuál es vuestro nombre de equipo?",
    pl: "Podaj nazwę drużyny?",
  },
  playerNameQuestion: {
    nl: "Wat is je naam?",
    en: "What is your name?",
    de: "Wie heißt du?",
    fr: "Quel est votre nom ?",
    es: "¿Cuál es su nombre?",
    pl: "Podaj imię?",
  },
  gamertagQuestion: {
    nl: "Wat is je gamertag?",
    en: "What is your gamertag?",
    de: "Was ist dein gamertag?",
    fr: "Quel est votre gamertag (pseudo) ?",
    es: "¿Cuál es tu gamertag?",
    pl: "Podaj swój tag gracza?",
  },
  individualPlayersQuestion: {
    nl: "Welke spelers zitten er in jouw team?",
    en: "Who are the players on your team?",
    de: "Wer sind die Spieler in deinem Team?",
    fr: "Qui sont les joueurs de votre équipe?",
    es: "Quiénes son los jugadores de tu equipo?",
    pl: "Kim są zawodnicy w twojej drużynie?",
  },
  teamCountryQuestion: {
    nl: "Uit welk land komt jouw team?",
    en: "Which country is your team representing?",
    de: "Aus welchem Land kommt dein Team?",
    fr: "De quel pays vient votre équipe ?",
    es: "¿De qué país es tu equipo?",
    pl: "Z którego kraju pochodzi twój zespół?",
  },
  playerCountryQuestion: {
    nl: "Welk land vertegenwoordig je?",
    en: "Which country are you representing?",
    de: "Welches Land vertrittst du?",
    fr: "Quel pays représentez-vous ?",
    es: "¿Qué país estás representando?",
    pl: "Który kraj reprezentujesz?",
  },
};
